import axios from 'axios';
import { extractApiError } from '../utils/errorUtils';
import { bridgeNotify } from '../utils/notificationBridge';

declare module 'axios' {
  interface AxiosRequestConfig {
    /** Unterdrückt den globalen Fehler-Toast. 401 leitet weiterhin zum Login um. */
    skipErrorNotify?: boolean;
  }
}

// API immer auf 127.0.0.1 (nicht localhost)
const API_BASE = "/api";

export { API_BASE };

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Bei FormData Content-Type entfernen – Browser setzt multipart/form-data inkl. Boundary
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

const isPublicAuthRoute = (pathname: string): boolean => {
  return (
    pathname === '/login' ||
    pathname === '/passwort-vergessen' ||
    pathname === '/passwort-reset' ||
    pathname.startsWith('/passwort-reset/') ||
    pathname.startsWith('/upload/')
  );
};

let redirectingTo401 = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) return Promise.reject(error);

    const status = error.response?.status;

    if (status === 401) {
      if (!redirectingTo401 && !isPublicAuthRoute(window.location.pathname)) {
        redirectingTo401 = true;
        window.location.href = '/login';
      }
    } else if (error.response && !error.config?.skipErrorNotify) {
      bridgeNotify(extractApiError(error), 'error');
    }

    return Promise.reject(error);
  }
);

export default api;
